/**
 * @flow
 * @relayHash 0d42d947d468dc6d2e9b4df7411a8189
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Product_productInfo$ref = any;
export type ProductSort = "a_to_z" | "best_selling" | "discount" | "highest_rating" | "most_popular" | "nearest" | "new_arrivals" | "price_asc" | "price_desc" | "z_to_a" | "%future added value";
export type VariantQueryInput = {
  mark_viewed?: ?boolean,
  root_variant_id: number,
  vendor_id?: ?number,
  sort?: ?ProductSort,
};
export type ProductDetailsQueryVariables = {|
  input?: ?VariantQueryInput
|};
export type ProductDetailsQueryResponse = {|
  +variant: {|
    +result: {|
      +departments: ?$ReadOnlyArray<?{|
        +ref_id: string,
        +name: string,
      |}>,
      +categories: ?$ReadOnlyArray<?{|
        +ref_id: string,
        +name: string,
      |}>,
      +current_user_review: ?{|
        +ref_id: string,
        +review: ?string,
        +rating: number,
      |},
      +root_variant_id: ?string,
      +product_type: ?string,
      +required_services_amount: ?number,
      +eligible_stock: ?boolean,
      +variant_services: ?$ReadOnlyArray<?{|
        +ref_id: string,
        +name: string,
      |}>,
      +root_variant: ?{|
        +wish_listed: ?boolean
      |},
      +summary: ?string,
      +name: string,
      +product_name: ?string,
      +ref_id: string,
      +id: string,
      +slug: ?string,
      +vendor_variants_count: ?number,
      +product_id: ?string,
      +refund_state: ?string,
      +display_price: ?string,
      +rating_count: ?number,
      +avg_rating: ?number,
      +images_attachments: $ReadOnlyArray<?{|
        +url_small: string,
        +url_product: string,
        +alt: string,
        +url_large: string,
        +url_original: string,
      |}>,
      +description: ?string,
      +gift_image: ?{|
        +url_large: string,
        +url_original: string,
      |},
      +gift_text: ?string,
      +gift_included: ?boolean,
      +brand: ?{|
        +name: string
      |},
      +made_in: ?{|
        +name: ?string
      |},
      +wish_listed: ?boolean,
      +price: number,
      +original_price: number,
      +option_values: ?$ReadOnlyArray<?{|
        +id: string,
        +ref_id: string,
        +presentation: ?string,
        +option_type_id: ?string,
        +option_type_name: ?string,
        +option_type_presentation: ?string,
      |}>,
      +vendor_available_variants: ?$ReadOnlyArray<?{|
        +name: string,
        +product_name: ?string,
        +ref_id: string,
        +id: string,
        +slug: ?string,
        +vendor_variants_count: ?number,
        +product_id: ?string,
        +refund_state: ?string,
        +display_price: ?string,
        +rating_count: ?number,
        +avg_rating: ?number,
        +images_attachments: $ReadOnlyArray<?{|
          +url_small: string,
          +url_product: string,
        |}>,
        +option_values: ?$ReadOnlyArray<?{|
          +id: string,
          +ref_id: string,
          +presentation: ?string,
          +option_type_id: ?string,
          +option_type_name: ?string,
          +option_type_presentation: ?string,
        |}>,
        +vendor: ?{|
          +id: string,
          +ref_id: string,
          +name: ?string,
          +avg_rating: ?number,
          +rating_count: ?number,
          +logo_url: ?string,
          +follow: ?boolean,
          +grouped_shipping_methods: ?$ReadOnlyArray<?{|
            +code: ?string,
            +title: ?string,
            +description: ?string,
          |}>,
          +payment_methods: $ReadOnlyArray<?{|
            +id: string,
            +ref_id: string,
            +name: string,
            +description: ?string,
            +type: string,
            +code: ?string,
          |}>,
          +featured: ?boolean,
          +departments: ?$ReadOnlyArray<?{|
            +id: string,
            +name: string,
          |}>,
        |},
        +min_variant: ?{|
          +vendor: ?{|
            +id: string,
            +ref_id: string,
            +name: ?string,
            +avg_rating: ?number,
            +rating_count: ?number,
            +logo_url: ?string,
            +follow: ?boolean,
            +grouped_shipping_methods: ?$ReadOnlyArray<?{|
              +code: ?string,
              +title: ?string,
              +description: ?string,
            |}>,
            +payment_methods: $ReadOnlyArray<?{|
              +id: string,
              +ref_id: string,
              +name: string,
              +description: ?string,
              +type: string,
              +code: ?string,
            |}>,
            +featured: ?boolean,
            +departments: ?$ReadOnlyArray<?{|
              +id: string,
              +name: string,
            |}>,
          |}
        |},
      |}>,
      +product_vendor_variants: ?$ReadOnlyArray<?{|
        +name: string,
        +product_name: ?string,
        +ref_id: string,
        +id: string,
        +slug: ?string,
        +vendor_variants_count: ?number,
        +product_id: ?string,
        +refund_state: ?string,
        +display_price: ?string,
        +rating_count: ?number,
        +avg_rating: ?number,
        +images_attachments: $ReadOnlyArray<?{|
          +url_small: string,
          +url_product: string,
        |}>,
        +min_variant: ?{|
          +vendor: ?{|
            +id: string,
            +ref_id: string,
            +name: ?string,
            +avg_rating: ?number,
            +rating_count: ?number,
            +logo_url: ?string,
            +follow: ?boolean,
            +grouped_shipping_methods: ?$ReadOnlyArray<?{|
              +code: ?string,
              +title: ?string,
              +description: ?string,
            |}>,
            +payment_methods: $ReadOnlyArray<?{|
              +id: string,
              +ref_id: string,
              +name: string,
              +description: ?string,
              +type: string,
              +code: ?string,
            |}>,
            +featured: ?boolean,
            +departments: ?$ReadOnlyArray<?{|
              +id: string,
              +name: string,
            |}>,
          |}
        |},
      |}>,
      +discount: ?number,
      +total_on_hand: ?number,
      +in_stock: boolean,
      +vendor: ?{|
        +id: string,
        +ref_id: string,
        +name: ?string,
        +avg_rating: ?number,
        +rating_count: ?number,
        +logo_url: ?string,
        +follow: ?boolean,
        +grouped_shipping_methods: ?$ReadOnlyArray<?{|
          +code: ?string,
          +title: ?string,
          +description: ?string,
        |}>,
        +payment_methods: $ReadOnlyArray<?{|
          +id: string,
          +ref_id: string,
          +name: string,
          +description: ?string,
          +type: string,
          +code: ?string,
        |}>,
        +featured: ?boolean,
        +departments: ?$ReadOnlyArray<?{|
          +id: string,
          +name: string,
          +ref_id: string,
          +enabled: ?boolean,
        |}>,
        +vendor_track: ?{|
          +name: ?string,
          +track_type: ?string,
        |},
      |},
      +product: ?{|
        +id: string,
        +ref_id: string,
        +name: string,
        +tax_status: ?string,
        +dimensions: ?string,
        +weight: ?string,
        +meta_keywords: ?string,
        +meta_description: ?string,
        +meta_title: ?string,
        +option_types: ?$ReadOnlyArray<?{|
          +id: string,
          +ref_id: string,
          +presentation: ?string,
          +option_values: ?$ReadOnlyArray<?{|
            +id: string,
            +ref_id: string,
            +presentation: ?string,
            +option_type_id: ?string,
            +option_type_name: ?string,
            +option_type_presentation: ?string,
          |}>,
        |}>,
        +size_chart: ?$ReadOnlyArray<?{|
          +id: string,
          +ref_id: string,
          +metric: ?$ReadOnlyArray<?string>,
        |}>,
        +product_properties: ?$ReadOnlyArray<?{|
          +id: string,
          +name: ?string,
          +presentation: ?string,
          +ref_id: string,
          +value: ?string,
        |}>,
        +root_variants: ?$ReadOnlyArray<?{|
          +name: string,
          +product_name: ?string,
          +ref_id: string,
          +id: string,
          +slug: ?string,
          +vendor_variants_count: ?number,
          +product_id: ?string,
          +refund_state: ?string,
          +display_price: ?string,
          +rating_count: ?number,
          +avg_rating: ?number,
          +images_attachments: $ReadOnlyArray<?{|
            +url_small: string,
            +url_product: string,
          |}>,
          +option_values: ?$ReadOnlyArray<?{|
            +id: string,
            +ref_id: string,
            +presentation: ?string,
            +option_type_id: ?string,
            +option_type_name: ?string,
            +option_type_presentation: ?string,
          |}>,
        |}>,
        +related_products: ?$ReadOnlyArray<?{|
          +$fragmentRefs: Product_productInfo$ref
        |}>,
      |},
      +available_in_offers: ?$ReadOnlyArray<?{|
        +name: string,
        +ref_id: string,
        +id: string,
        +slug: ?string,
        +vendor_variants_count: ?number,
        +min_variant: ?{|
          +vendor: ?{|
            +id: string,
            +ref_id: string,
            +name: ?string,
            +avg_rating: ?number,
            +rating_count: ?number,
            +logo_url: ?string,
            +follow: ?boolean,
            +grouped_shipping_methods: ?$ReadOnlyArray<?{|
              +code: ?string,
              +title: ?string,
              +description: ?string,
            |}>,
            +payment_methods: $ReadOnlyArray<?{|
              +id: string,
              +ref_id: string,
              +name: string,
              +description: ?string,
              +type: string,
              +code: ?string,
            |}>,
            +featured: ?boolean,
            +departments: ?$ReadOnlyArray<?{|
              +id: string,
              +name: string,
            |}>,
          |}
        |},
      |}>,
      +offered_variants: ?$ReadOnlyArray<?{|
        +quantity: ?number,
        +variant: ?{|
          +name: string,
          +product_name: ?string,
          +ref_id: string,
          +id: string,
          +slug: ?string,
          +vendor_variants_count: ?number,
          +product_id: ?string,
          +refund_state: ?string,
          +display_price: ?string,
          +rating_count: ?number,
          +avg_rating: ?number,
          +images_attachments: $ReadOnlyArray<?{|
            +url_small: string,
            +url_product: string,
          |}>,
          +min_variant: ?{|
            +vendor: ?{|
              +id: string,
              +ref_id: string,
              +name: ?string,
              +avg_rating: ?number,
              +rating_count: ?number,
              +logo_url: ?string,
              +follow: ?boolean,
              +grouped_shipping_methods: ?$ReadOnlyArray<?{|
                +code: ?string,
                +title: ?string,
                +description: ?string,
              |}>,
              +payment_methods: $ReadOnlyArray<?{|
                +id: string,
                +ref_id: string,
                +name: string,
                +description: ?string,
                +type: string,
                +code: ?string,
              |}>,
              +featured: ?boolean,
              +departments: ?$ReadOnlyArray<?{|
                +id: string,
                +name: string,
              |}>,
            |}
          |},
          +option_values: ?$ReadOnlyArray<?{|
            +id: string,
            +ref_id: string,
            +presentation: ?string,
            +option_type_id: ?string,
            +option_type_name: ?string,
            +option_type_presentation: ?string,
          |}>,
        |},
      |}>,
      +has_offer: ?boolean,
      +has_discount: ?boolean,
      +hot_deal: ?boolean,
      +offer_saved_amount: ?number,
      +offer_saved_percent: ?number,
    |},
    +errors: ?$ReadOnlyArray<?{|
      +field: ?string,
      +messages: ?$ReadOnlyArray<?string>,
      +code: ?number,
    |}>,
  |}
|};
export type ProductDetailsQuery = {|
  variables: ProductDetailsQueryVariables,
  response: ProductDetailsQueryResponse,
|};
*/


/*
query ProductDetailsQuery(
  $input: VariantQueryInput
) {
  variant(input: $input) {
    result {
      departments {
        ref_id
        name
        id
      }
      categories {
        ref_id
        name
        id
      }
      current_user_review {
        ref_id
        review
        rating
        id
      }
      root_variant_id
      product_type
      required_services_amount
      eligible_stock
      variant_services {
        ref_id
        name
        id
      }
      root_variant {
        wish_listed
        id
      }
      summary
      name
      product_name
      ref_id
      id
      slug
      vendor_variants_count
      product_id
      refund_state
      display_price
      rating_count
      avg_rating
      images_attachments {
        url_small
        url_product
        alt
        url_large
        url_original
      }
      description
      gift_image {
        url_large
        url_original
      }
      gift_text
      gift_included
      brand {
        name
        id
      }
      made_in {
        name
        id
      }
      wish_listed
      price
      original_price
      option_values {
        id
        ref_id
        presentation
        option_type_id
        option_type_name
        option_type_presentation
      }
      vendor_available_variants {
        name
        product_name
        ref_id
        id
        slug
        vendor_variants_count
        product_id
        refund_state
        display_price
        rating_count
        avg_rating
        images_attachments {
          url_small
          url_product
        }
        option_values {
          id
          ref_id
          presentation
          option_type_id
          option_type_name
          option_type_presentation
        }
        vendor {
          id
          ref_id
          name
          avg_rating
          rating_count
          logo_url
          follow
          grouped_shipping_methods {
            code
            title
            description
          }
          payment_methods {
            id
            ref_id
            name
            description
            type
            code
          }
          featured
          departments {
            id
            name
          }
        }
        min_variant {
          vendor {
            id
            ref_id
            name
            avg_rating
            rating_count
            logo_url
            follow
            grouped_shipping_methods {
              code
              title
              description
            }
            payment_methods {
              id
              ref_id
              name
              description
              type
              code
            }
            featured
            departments {
              id
              name
            }
          }
          id
        }
      }
      product_vendor_variants {
        name
        product_name
        ref_id
        id
        slug
        vendor_variants_count
        product_id
        refund_state
        display_price
        rating_count
        avg_rating
        images_attachments {
          url_small
          url_product
        }
        min_variant {
          vendor {
            id
            ref_id
            name
            avg_rating
            rating_count
            logo_url
            follow
            grouped_shipping_methods {
              code
              title
              description
            }
            payment_methods {
              id
              ref_id
              name
              description
              type
              code
            }
            featured
            departments {
              id
              name
            }
          }
          id
        }
      }
      discount
      total_on_hand
      in_stock
      vendor {
        id
        ref_id
        name
        avg_rating
        rating_count
        logo_url
        follow
        grouped_shipping_methods {
          code
          title
          description
        }
        payment_methods {
          id
          ref_id
          name
          description
          type
          code
        }
        featured
        departments {
          id
          name
          ref_id
          enabled
        }
        vendor_track {
          name
          track_type
          id
        }
      }
      product {
        id
        ref_id
        name
        tax_status
        dimensions
        weight
        meta_keywords
        meta_description
        meta_title
        option_types {
          id
          ref_id
          presentation
          option_values {
            id
            ref_id
            presentation
            option_type_id
            option_type_name
            option_type_presentation
          }
        }
        size_chart {
          id
          ref_id
          metric
        }
        product_properties {
          id
          name
          presentation
          ref_id
          value
        }
        root_variants {
          name
          product_name
          ref_id
          id
          slug
          vendor_variants_count
          product_id
          refund_state
          display_price
          rating_count
          avg_rating
          images_attachments {
            url_small
            url_product
          }
          option_values {
            id
            ref_id
            presentation
            option_type_id
            option_type_name
            option_type_presentation
          }
        }
        related_products {
          ...Product_productInfo
          id
        }
      }
      available_in_offers {
        name
        ref_id
        id
        slug
        vendor_variants_count
        min_variant {
          vendor {
            id
            ref_id
            name
            avg_rating
            rating_count
            logo_url
            follow
            grouped_shipping_methods {
              code
              title
              description
            }
            payment_methods {
              id
              ref_id
              name
              description
              type
              code
            }
            featured
            departments {
              id
              name
            }
          }
          id
        }
      }
      offered_variants {
        quantity
        variant {
          name
          product_name
          ref_id
          id
          slug
          vendor_variants_count
          product_id
          refund_state
          display_price
          rating_count
          avg_rating
          images_attachments {
            url_small
            url_product
          }
          min_variant {
            vendor {
              id
              ref_id
              name
              avg_rating
              rating_count
              logo_url
              follow
              grouped_shipping_methods {
                code
                title
                description
              }
              payment_methods {
                id
                ref_id
                name
                description
                type
                code
              }
              featured
              departments {
                id
                name
              }
            }
            id
          }
          option_values {
            id
            ref_id
            presentation
            option_type_id
            option_type_name
            option_type_presentation
          }
        }
      }
      has_offer
      has_discount
      hot_deal
      offer_saved_amount
      offer_saved_percent
    }
    errors {
      field
      messages
      code
    }
  }
}

fragment Product_productInfo on Product {
  id
  slug
  vendor_variants_count
  min_variant {
    vendor {
      name
      ref_id
      id
    }
    slug
    name
    ref_id
    root_variant_id
    discount_expire_at
    remaining_usage_percentage
    total_on_hand
    price
    original_price
    id
  }
  ref_id
  images
  name
  avg_rating
  rating_count
  price
  original_price
  discount
  has_discount
  has_offer
  hot_deal
  wish_listed
  root_variant {
    root_variant_id
    ref_id
    wish_listed
    id
  }
  variants {
    id
    ref_id
    option_values {
      id
      ref_id
      option_type_name
    }
  }
  related_products {
    images
    name
    id
  }
  gift_image {
    url_large
    url_original
  }
  gift_text
  gift_included
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "VariantQueryInput",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "VariantQueryInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url_large",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url_original",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "gift_image",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageAttachment",
  "plural": false,
  "selections": [
    v2,
    v3
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = [
  v5,
  v6
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "review",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rating",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "root_variant_id",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "product_type",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "required_services_amount",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "eligible_stock",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "wish_listed",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "summary",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "product_name",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vendor_variants_count",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "product_id",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "refund_state",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "display_price",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rating_count",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "avg_rating",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url_small",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url_product",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "images_attachments",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageAttachment",
  "plural": true,
  "selections": [
    v25,
    v26,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "alt",
      "args": null,
      "storageKey": null
    },
    v2,
    v3
  ]
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "gift_text",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "gift_included",
  "args": null,
  "storageKey": null
},
v31 = [
  v6
],
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "original_price",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "presentation",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "option_type_name",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "option_values",
  "storageKey": null,
  "args": null,
  "concreteType": "OptionValue",
  "plural": true,
  "selections": [
    v17,
    v5,
    v34,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "option_type_id",
      "args": null,
      "storageKey": null
    },
    v35,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "option_type_presentation",
      "args": null,
      "storageKey": null
    }
  ]
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "images_attachments",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageAttachment",
  "plural": true,
  "selections": [
    v25,
    v26
  ]
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logo_url",
  "args": null,
  "storageKey": null
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "follow",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "grouped_shipping_methods",
  "storageKey": null,
  "args": null,
  "concreteType": "VendorGroupedShipmentResult",
  "plural": true,
  "selections": [
    v40,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    v28
  ]
},
v42 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "payment_methods",
  "storageKey": null,
  "args": null,
  "concreteType": "PaymentMethod",
  "plural": true,
  "selections": [
    v17,
    v5,
    v6,
    v28,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    v40
  ]
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "featured",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "vendor",
  "storageKey": null,
  "args": null,
  "concreteType": "Shop",
  "plural": false,
  "selections": [
    v38,
    v17,
    v6,
    v24,
    v23,
    v5,
    v39,
    v41,
    v42,
    v43,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "departments",
      "storageKey": null,
      "args": null,
      "concreteType": "TrackDepartment",
      "plural": true,
      "selections": [
        v17,
        v6
      ]
    }
  ]
},
v45 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "min_variant",
  "storageKey": null,
  "args": null,
  "concreteType": "Variant",
  "plural": false,
  "selections": [
    v44
  ]
},
v46 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "discount",
  "args": null,
  "storageKey": null
},
v47 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "total_on_hand",
  "args": null,
  "storageKey": null
},
v48 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "in_stock",
  "args": null,
  "storageKey": null
},
v49 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "departments",
  "storageKey": null,
  "args": null,
  "concreteType": "TrackDepartment",
  "plural": true,
  "selections": [
    v17,
    v6,
    v5,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "enabled",
      "args": null,
      "storageKey": null
    }
  ]
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "track_type",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "meta_description",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tax_status",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dimensions",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "weight",
  "args": null,
  "storageKey": null
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "meta_keywords",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "meta_title",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "option_types",
  "storageKey": null,
  "args": null,
  "concreteType": "OptionType",
  "plural": true,
  "selections": [
    v17,
    v5,
    v34,
    v36
  ]
},
v58 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "size_chart",
  "storageKey": null,
  "args": null,
  "concreteType": "SizeChart",
  "plural": true,
  "selections": [
    v17,
    v5,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metric",
      "args": null,
      "storageKey": null
    }
  ]
},
v59 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "product_properties",
  "storageKey": null,
  "args": null,
  "concreteType": "Property",
  "plural": true,
  "selections": [
    v17,
    v6,
    v34,
    v5,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "value",
      "args": null,
      "storageKey": null
    }
  ]
},
v60 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "root_variants",
  "storageKey": null,
  "args": null,
  "concreteType": "Variant",
  "plural": true,
  "selections": [
    v20,
    v6,
    v5,
    v17,
    v18,
    v19,
    v16,
    v21,
    v22,
    v23,
    v24,
    v37,
    v36
  ]
},
v61 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v62 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "has_offer",
  "args": null,
  "storageKey": null
},
v63 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "has_discount",
  "args": null,
  "storageKey": null
},
v64 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hot_deal",
  "args": null,
  "storageKey": null
},
v65 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "offer_saved_amount",
  "args": null,
  "storageKey": null
},
v66 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "offer_saved_percent",
  "args": null,
  "storageKey": null
},
v67 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "field",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "messages",
      "args": null,
      "storageKey": null
    },
    v40
  ]
},
v68 = [
  v5,
  v6,
  v17
],
v69 = [
  v6,
  v17
],
v70 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "min_variant",
  "storageKey": null,
  "args": null,
  "concreteType": "Variant",
  "plural": false,
  "selections": [
    v44,
    v17
  ]
},
v71 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "images",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ProductDetailsQuery",
  "id": null,
  "text": "query ProductDetailsQuery(\n  $input: VariantQueryInput\n) {\n  variant(input: $input) {\n    result {\n      departments {\n        ref_id\n        name\n        id\n      }\n      categories {\n        ref_id\n        name\n        id\n      }\n      current_user_review {\n        ref_id\n        review\n        rating\n        id\n      }\n      root_variant_id\n      product_type\n      required_services_amount\n      eligible_stock\n      variant_services {\n        ref_id\n        name\n        id\n      }\n      root_variant {\n        wish_listed\n        id\n      }\n      summary\n      name\n      product_name\n      ref_id\n      id\n      slug\n      vendor_variants_count\n      product_id\n      refund_state\n      display_price\n      rating_count\n      avg_rating\n      images_attachments {\n        url_small\n        url_product\n        alt\n        url_large\n        url_original\n      }\n      description\n      gift_image {\n        url_large\n        url_original\n      }\n      gift_text\n      gift_included\n      brand {\n        name\n        id\n      }\n      made_in {\n        name\n        id\n      }\n      wish_listed\n      price\n      original_price\n      option_values {\n        id\n        ref_id\n        presentation\n        option_type_id\n        option_type_name\n        option_type_presentation\n      }\n      vendor_available_variants {\n        name\n        product_name\n        ref_id\n        id\n        slug\n        vendor_variants_count\n        product_id\n        refund_state\n        display_price\n        rating_count\n        avg_rating\n        images_attachments {\n          url_small\n          url_product\n        }\n        option_values {\n          id\n          ref_id\n          presentation\n          option_type_id\n          option_type_name\n          option_type_presentation\n        }\n        vendor {\n          id\n          ref_id\n          name\n          avg_rating\n          rating_count\n          logo_url\n          follow\n          grouped_shipping_methods {\n            code\n            title\n            description\n          }\n          payment_methods {\n            id\n            ref_id\n            name\n            description\n            type\n            code\n          }\n          featured\n          departments {\n            id\n            name\n          }\n        }\n        min_variant {\n          vendor {\n            id\n            ref_id\n            name\n            avg_rating\n            rating_count\n            logo_url\n            follow\n            grouped_shipping_methods {\n              code\n              title\n              description\n            }\n            payment_methods {\n              id\n              ref_id\n              name\n              description\n              type\n              code\n            }\n            featured\n            departments {\n              id\n              name\n            }\n          }\n          id\n        }\n      }\n      product_vendor_variants {\n        name\n        product_name\n        ref_id\n        id\n        slug\n        vendor_variants_count\n        product_id\n        refund_state\n        display_price\n        rating_count\n        avg_rating\n        images_attachments {\n          url_small\n          url_product\n        }\n        min_variant {\n          vendor {\n            id\n            ref_id\n            name\n            avg_rating\n            rating_count\n            logo_url\n            follow\n            grouped_shipping_methods {\n              code\n              title\n              description\n            }\n            payment_methods {\n              id\n              ref_id\n              name\n              description\n              type\n              code\n            }\n            featured\n            departments {\n              id\n              name\n            }\n          }\n          id\n        }\n      }\n      discount\n      total_on_hand\n      in_stock\n      vendor {\n        id\n        ref_id\n        name\n        avg_rating\n        rating_count\n        logo_url\n        follow\n        grouped_shipping_methods {\n          code\n          title\n          description\n        }\n        payment_methods {\n          id\n          ref_id\n          name\n          description\n          type\n          code\n        }\n        featured\n        departments {\n          id\n          name\n          ref_id\n          enabled\n        }\n        vendor_track {\n          name\n          track_type\n          id\n        }\n      }\n      product {\n        id\n        ref_id\n        name\n        tax_status\n        dimensions\n        weight\n        meta_keywords\n        meta_description\n        meta_title\n        option_types {\n          id\n          ref_id\n          presentation\n          option_values {\n            id\n            ref_id\n            presentation\n            option_type_id\n            option_type_name\n            option_type_presentation\n          }\n        }\n        size_chart {\n          id\n          ref_id\n          metric\n        }\n        product_properties {\n          id\n          name\n          presentation\n          ref_id\n          value\n        }\n        root_variants {\n          name\n          product_name\n          ref_id\n          id\n          slug\n          vendor_variants_count\n          product_id\n          refund_state\n          display_price\n          rating_count\n          avg_rating\n          images_attachments {\n            url_small\n            url_product\n          }\n          option_values {\n            id\n            ref_id\n            presentation\n            option_type_id\n            option_type_name\n            option_type_presentation\n          }\n        }\n        related_products {\n          ...Product_productInfo\n          id\n        }\n      }\n      available_in_offers {\n        name\n        ref_id\n        id\n        slug\n        vendor_variants_count\n        min_variant {\n          vendor {\n            id\n            ref_id\n            name\n            avg_rating\n            rating_count\n            logo_url\n            follow\n            grouped_shipping_methods {\n              code\n              title\n              description\n            }\n            payment_methods {\n              id\n              ref_id\n              name\n              description\n              type\n              code\n            }\n            featured\n            departments {\n              id\n              name\n            }\n          }\n          id\n        }\n      }\n      offered_variants {\n        quantity\n        variant {\n          name\n          product_name\n          ref_id\n          id\n          slug\n          vendor_variants_count\n          product_id\n          refund_state\n          display_price\n          rating_count\n          avg_rating\n          images_attachments {\n            url_small\n            url_product\n          }\n          min_variant {\n            vendor {\n              id\n              ref_id\n              name\n              avg_rating\n              rating_count\n              logo_url\n              follow\n              grouped_shipping_methods {\n                code\n                title\n                description\n              }\n              payment_methods {\n                id\n                ref_id\n                name\n                description\n                type\n                code\n              }\n              featured\n              departments {\n                id\n                name\n              }\n            }\n            id\n          }\n          option_values {\n            id\n            ref_id\n            presentation\n            option_type_id\n            option_type_name\n            option_type_presentation\n          }\n        }\n      }\n      has_offer\n      has_discount\n      hot_deal\n      offer_saved_amount\n      offer_saved_percent\n    }\n    errors {\n      field\n      messages\n      code\n    }\n  }\n}\n\nfragment Product_productInfo on Product {\n  id\n  slug\n  vendor_variants_count\n  min_variant {\n    vendor {\n      name\n      ref_id\n      id\n    }\n    slug\n    name\n    ref_id\n    root_variant_id\n    discount_expire_at\n    remaining_usage_percentage\n    total_on_hand\n    price\n    original_price\n    id\n  }\n  ref_id\n  images\n  name\n  avg_rating\n  rating_count\n  price\n  original_price\n  discount\n  has_discount\n  has_offer\n  hot_deal\n  wish_listed\n  root_variant {\n    root_variant_id\n    ref_id\n    wish_listed\n    id\n  }\n  variants {\n    id\n    ref_id\n    option_values {\n      id\n      ref_id\n      option_type_name\n    }\n  }\n  related_products {\n    images\n    name\n    id\n  }\n  gift_image {\n    url_large\n    url_original\n  }\n  gift_text\n  gift_included\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ProductDetailsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "variant",
        "storageKey": null,
        "args": v1,
        "concreteType": "VariantQueryResult",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "result",
            "storageKey": null,
            "args": null,
            "concreteType": "Variant",
            "plural": false,
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "departments",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxon",
                "plural": true,
                "selections": v7
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "current_user_review",
                "storageKey": null,
                "args": null,
                "concreteType": "VariantReview",
                "plural": false,
                "selections": [
                  v5,
                  v8,
                  v9
                ]
              },
              v10,
              v11,
              v12,
              v13,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "variant_services",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": true,
                "selections": v7
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "root_variant",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": false,
                "selections": [
                  v14
                ]
              },
              v15,
              v6,
              v16,
              v5,
              v17,
              v18,
              v19,
              v20,
              v21,
              v22,
              v23,
              v24,
              v27,
              v28,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categories",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxon",
                "plural": true,
                "selections": v7
              },
              v29,
              v30,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "brand",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxon",
                "plural": false,
                "selections": v31
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "made_in",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": v31
              },
              v14,
              v32,
              v33,
              v36,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor_available_variants",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": true,
                "selections": [
                  v21,
                  v6,
                  v5,
                  v17,
                  v18,
                  v19,
                  v20,
                  v16,
                  v22,
                  v23,
                  v24,
                  v37,
                  v36,
                  v44,
                  v45
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "product_vendor_variants",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": true,
                "selections": [
                  v20,
                  v6,
                  v5,
                  v17,
                  v18,
                  v19,
                  v16,
                  v21,
                  v22,
                  v23,
                  v24,
                  v37,
                  v45
                ]
              },
              v46,
              v47,
              v48,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Shop",
                "plural": false,
                "selections": [
                  v39,
                  v17,
                  v6,
                  v24,
                  v23,
                  v38,
                  v5,
                  v41,
                  v42,
                  v43,
                  v49,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor_track",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorTrack",
                    "plural": false,
                    "selections": [
                      v6,
                      v50
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "product",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": false,
                "selections": [
                  v51,
                  v17,
                  v6,
                  v52,
                  v53,
                  v54,
                  v55,
                  v5,
                  v56,
                  v57,
                  v58,
                  v59,
                  v60,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "related_products",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Product",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "Product_productInfo",
                        "args": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "available_in_offers",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": true,
                "selections": [
                  v6,
                  v5,
                  v17,
                  v18,
                  v19,
                  v45
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "offered_variants",
                "storageKey": null,
                "args": null,
                "concreteType": "OfferedVariant",
                "plural": true,
                "selections": [
                  v61,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "variant",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Variant",
                    "plural": false,
                    "selections": [
                      v21,
                      v6,
                      v5,
                      v17,
                      v18,
                      v19,
                      v20,
                      v16,
                      v22,
                      v23,
                      v24,
                      v37,
                      v45,
                      v36
                    ]
                  }
                ]
              },
              v62,
              v63,
              v64,
              v65,
              v66
            ]
          },
          v67
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProductDetailsQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "variant",
        "storageKey": null,
        "args": v1,
        "concreteType": "VariantQueryResult",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "result",
            "storageKey": null,
            "args": null,
            "concreteType": "Variant",
            "plural": false,
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "departments",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxon",
                "plural": true,
                "selections": v68
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "current_user_review",
                "storageKey": null,
                "args": null,
                "concreteType": "VariantReview",
                "plural": false,
                "selections": [
                  v5,
                  v8,
                  v9,
                  v17
                ]
              },
              v10,
              v11,
              v12,
              v13,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "variant_services",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": true,
                "selections": v68
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "root_variant",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": false,
                "selections": [
                  v14,
                  v17
                ]
              },
              v15,
              v6,
              v16,
              v5,
              v17,
              v18,
              v19,
              v20,
              v21,
              v22,
              v23,
              v24,
              v27,
              v28,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categories",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxon",
                "plural": true,
                "selections": v68
              },
              v29,
              v30,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "brand",
                "storageKey": null,
                "args": null,
                "concreteType": "Taxon",
                "plural": false,
                "selections": v69
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "made_in",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": v69
              },
              v14,
              v32,
              v33,
              v36,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor_available_variants",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": true,
                "selections": [
                  v21,
                  v6,
                  v5,
                  v17,
                  v18,
                  v19,
                  v20,
                  v16,
                  v22,
                  v23,
                  v24,
                  v37,
                  v36,
                  v44,
                  v70
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "product_vendor_variants",
                "storageKey": null,
                "args": null,
                "concreteType": "Variant",
                "plural": true,
                "selections": [
                  v20,
                  v6,
                  v5,
                  v17,
                  v18,
                  v19,
                  v16,
                  v21,
                  v22,
                  v23,
                  v24,
                  v37,
                  v70
                ]
              },
              v46,
              v47,
              v48,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Shop",
                "plural": false,
                "selections": [
                  v39,
                  v17,
                  v6,
                  v24,
                  v23,
                  v38,
                  v5,
                  v41,
                  v42,
                  v43,
                  v49,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor_track",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorTrack",
                    "plural": false,
                    "selections": [
                      v6,
                      v50,
                      v17
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "product",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": false,
                "selections": [
                  v51,
                  v17,
                  v6,
                  v52,
                  v53,
                  v54,
                  v55,
                  v5,
                  v56,
                  v57,
                  v58,
                  v59,
                  v60,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "related_products",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Product",
                    "plural": true,
                    "selections": [
                      v46,
                      v17,
                      v19,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "min_variant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "discount_expire_at",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "vendor",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Shop",
                            "plural": false,
                            "selections": [
                              v6,
                              v5,
                              v17
                            ]
                          },
                          v6,
                          v5,
                          v10,
                          v18,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "remaining_usage_percentage",
                            "args": null,
                            "storageKey": null
                          },
                          v47,
                          v32,
                          v33,
                          v17
                        ]
                      },
                      v5,
                      v71,
                      v6,
                      v24,
                      v23,
                      v32,
                      v33,
                      v18,
                      v63,
                      v62,
                      v64,
                      v14,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "root_variant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": false,
                        "selections": [
                          v10,
                          v5,
                          v14,
                          v17
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variants",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": true,
                        "selections": [
                          v17,
                          v5,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "option_values",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "OptionValue",
                            "plural": true,
                            "selections": [
                              v17,
                              v5,
                              v35
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "related_products",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Product",
                        "plural": true,
                        "selections": [
                          v71,
                          v6,
                          v17
                        ]
                      },
                      v4,
                      v29,
                      v30
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "available_in_offers",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": true,
                "selections": [
                  v6,
                  v5,
                  v17,
                  v18,
                  v19,
                  v70
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "offered_variants",
                "storageKey": null,
                "args": null,
                "concreteType": "OfferedVariant",
                "plural": true,
                "selections": [
                  v61,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "variant",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Variant",
                    "plural": false,
                    "selections": [
                      v21,
                      v6,
                      v5,
                      v17,
                      v18,
                      v19,
                      v20,
                      v16,
                      v22,
                      v23,
                      v24,
                      v37,
                      v70,
                      v36
                    ]
                  }
                ]
              },
              v62,
              v63,
              v64,
              v65,
              v66
            ]
          },
          v67
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '790c719d9704e70c82f12ce5dd6f18a5';
module.exports = node;
